import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from 'ic-snacks'
import EmptyView from 'legacy/components/EmptyView'
import { useGoToAddStoreGroup } from 'legacy/sections/store-groups/utils/navigation.hooks'

export const StoreGroupsListEmptyState: FunctionComponent = () => {
  const goToAddStoreGroup = useGoToAddStoreGroup()

  return (
    <EmptyView
      size="large"
      iconName="folder"
      title={<FormattedMessage id="settings.storeGroups.list.emptyState.title" />}
      body={<FormattedMessage id="settings.storeGroups.list.emptyState.body" />}
      action={
        <Button
          onClick={goToAddStoreGroup}
          elementAttributes={{ 'data-testid': 'add-group-empty-state-button' }}
        >
          <FormattedMessage id="settings.storeGroups.list.emptyState.addGroup" />
        </Button>
      }
    />
  )
}
